/* eslint-disable no-multi-assign */
/* eslint-disable no-nested-ternary */
interface UrlObject {
  host: string;
  hostname: string;
  pathname: string;
  hash: string;
  search: string;
  href: string;
  protocol: string;
  origin: string;
}

/**
 * @param {string} url url to parse (url must be decoded before passing to this util)
 */
export function parseUrlToObject(url: string): UrlObject {
  const obj = {} as UrlObject;

  if (typeof document !== 'undefined' && document.createElement) {
    const elem = document.createElement('a');
    elem.href = url;

    // Reference: https://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
    const {host, hostname, pathname, hash, search, origin, href, protocol,} = elem;

    return {
      host,

      /**
       * [IE omits the leading slash in `elem.href.pathname`](https://stackoverflow.com/questions/956233/javascript-pathname-ie-quirk)
       */
      pathname:
        pathname !== '' && pathname[0] !== '/' ? `/${pathname}` : pathname,
      hostname,
      hash,
      search,
      href,
      protocol,

      /**
       * [`origin` not available in IE and Opera](https://developer.mozilla.org/en-US/docs/Web/API/HTMLHyperlinkElementUtils/origin)
       */
      origin: origin || `${protocol}://${host}`,
    };
  }
  const hostStart = url.indexOf('://') + 3;
  const pathStart = url.indexOf('/', hostStart);
  let searchStart = url.indexOf('?');
  const hashStart = url.indexOf('#');
  // in case url like https://example.com/no#arekiddingme?
  if (hashStart !== -1 && searchStart > hashStart) {
    searchStart = -1;
  }

  obj.protocol = url.slice(0, hostStart);
  obj.hostname = obj.host = pathStart !== -1
    ? url.slice(hostStart, pathStart)
    : searchStart !== -1
      ? url.slice(hostStart, searchStart)
      : hashStart !== -1
        ? url.slice(hostStart, hashStart)
        : url.slice(hostStart);
  obj.pathname = pathStart !== -1
    ? searchStart !== -1
      ? url.slice(pathStart, searchStart)
      : hashStart !== -1
        ? url.slice(pathStart, hashStart)
        : url.slice(pathStart)
    : '/';
  obj.search = searchStart !== -1
    ? hashStart !== -1
      ? url.slice(searchStart, hashStart)
      : url.slice(searchStart)
    : '';
  obj.hash = hashStart !== -1 ? url.slice(hashStart) : '';
  return obj;
}
